import React from 'react';
import Link from "./Application/Link";
import classnames from "classnames";
import {useTranslation} from "react-i18next";

const Breadcrumb = props => {
  const { t } = useTranslation()
  const getCrumbs = () => {
    return props?.crumbs?.filter(crumb => crumb.hidden !== true)
  }

  const isLast = (key) => {
    return (getCrumbs().length-1) === key;
  }

  return (
    <ol className="breadcrumb mb-0 bg-transparent border-0 px-0 d-flex flex-row flex-nowrap align-items-center" style={{ maxWidth: '100%' }}>
      {getCrumbs()?.map((crumb, key) => {
        return <li
          key={key.toString()}
          className={classnames({
            'breadcrumb-item text-ellipsis': true,
            'active': isLast(key) && getCrumbs().length > 1
          })}
          >{
            (isLast(key) && getCrumbs().length > 1)
              ? (crumb.nameTranslation ? t(crumb.nameTranslation) : crumb.name)
              : <Link
                to={crumb.path || '#'}
                disableRedirect={!!crumb.disableRedirect}
                className="text-nowrap"
                onClick={crumb.onClick}
              >{crumb.nameTranslation ? t(crumb.nameTranslation) : crumb.name}</Link>
          }
          </li>
      })}
    </ol>
  );
};

Breadcrumb.propTypes = {

};

export default Breadcrumb;
